<template>
  <div id="myDateShow">
    <div class="title">{{coveShedAddress.id?"修改":"新增"}} 心坞栈区域</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">区域名称(市/区)</div>
        <div class="value">
          <el-input class="w500" v-model="coveShedAddress.labelName" placeholder="请填写区域名称"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">社区名称</div>
        <div class="value">
          <el-input class="w500" v-model="coveShedAddress.labelTwoName" placeholder="请填写社区名称"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key"></div>
        <div class="value">
          <el-button type="primary" size="medium" @click="submit">提交信息</el-button>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getCoveShedAddressById, newVue, updateCoveShedAddress} from "../../network/coveShedAddress";

  export default {
    name: "LabelInsert",
    data(){
      return{
        coveShedAddress: {},
        labelId: '',
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href = "/coveShedAddress/list";
      this.common.HeaderLocationTwo.name = "心坞栈区域管理";
      this.common.HeaderLocationThree.name = "新增or修改心坞栈区域"
      if (this.$route.params.id!=null){
        this.labelId = this.$route.params.id;

        getCoveShedAddressById(this.labelId).then(res => {
          this.coveShedAddress = res.data;
        })
      }


    },
    methods: {
      backClick(){
        this.$router.push("../list");
      },
      submit(){
        updateCoveShedAddress(this.coveShedAddress).then(res => {
          console.log(res);
        })
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";
  .w500{
    width: 500px;
  }
</style>
